import React from 'react'
import './App.css'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Link } from 'react-router-dom'
/**
 * https://reactjs-kr.firebaseapp.com/docs/typechecking-with-proptypes.html
 * @returns {JSX.Element}
 * @constructor
 */
function App() {
  const queryClient = new QueryClient()
  return (
    <QueryClientProvider client={queryClient}>
      <div className="status">
        <span>💭</span>
        좋은 동료가 되기 위해 다방면으로 노력합니다
      </div>
      <div className="desc"></div>
      <ul className="vcard-details">
        <li
          className="vcard-detail pt-1 hide-sm hide-md"
          itemProp="worksFor"
          aria-label="Organization: Naver"
        >
          <svg
            className="octicon octicon-organization"
            viewBox="0 0 16 16"
            version="1.1"
            width="16"
            height="16"
            aria-hidden="true"
          >
            <path d="M1.75 16A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0h8.5C11.216 0 12 .784 12 1.75v12.5c0 .085-.006.168-.018.25h2.268a.25.25 0 0 0 .25-.25V8.285a.25.25 0 0 0-.111-.208l-1.055-.703a.749.749 0 1 1 .832-1.248l1.055.703c.487.325.779.871.779 1.456v5.965A1.75 1.75 0 0 1 14.25 16h-3.5a.766.766 0 0 1-.197-.026c-.099.017-.2.026-.303.026h-3a.75.75 0 0 1-.75-.75V14h-1v1.25a.75.75 0 0 1-.75.75Zm-.25-1.75c0 .138.112.25.25.25H4v-1.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.25h2.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM3.75 6h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 3.75A.75.75 0 0 1 3.75 3h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 3.75Zm4 3A.75.75 0 0 1 7.75 6h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 7 6.75ZM7.75 3h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 9.75A.75.75 0 0 1 3.75 9h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 9.75ZM7.75 9h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"></path>
          </svg>
          <span className="p-org">
            <div>Naver</div>
          </span>
        </li>
        <li
          className="vcard-detail pt-1 hide-sm hide-md"
          itemProp="homeLocation"
          aria-label="Home location: Korea"
        >
          <svg
            className="octicon octicon-location"
            viewBox="0 0 16 16"
            version="1.1"
            width="16"
            height="16"
            aria-hidden="true"
          >
            <path d="m12.596 11.596-3.535 3.536a1.5 1.5 0 0 1-2.122 0l-3.535-3.536a6.5 6.5 0 1 1 9.192-9.193 6.5 6.5 0 0 1 0 9.193Zm-1.06-8.132v-.001a5 5 0 1 0-7.072 7.072L8 14.07l3.536-3.534a5 5 0 0 0 0-7.072ZM8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 9Z"></path>
          </svg>
          <span className="p-label">Korea</span>
        </li>
        <li
          itemProp="email"
          aria-label="Email: insidedw@gmail.com"
          className="vcard-detail pt-1 "
        >
          <svg
            className="octicon octicon-mail"
            viewBox="0 0 16 16"
            version="1.1"
            width="16"
            height="16"
            aria-hidden="true"
          >
            <path d="M1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25v-8.5C0 2.784.784 2 1.75 2ZM1.5 12.251c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V5.809L8.38 9.397a.75.75 0 0 1-.76 0L1.5 5.809v6.442Zm13-8.181v-.32a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v.32L8 7.88Z"></path>
          </svg>
          <a
            className="Link--primary wb-break-all"
            href="mailto:insidedw@gmail.com"
          >
            insidedw@gmail.com
          </a>
        </li>
        <li itemProp="social" className="vcard-detail pt-1 ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            role="img"
            aria-labelledby="alfs23b28ske8ciezgc6gcebohjshs9k"
            className="octicon"
          >
            <title id="alfs23b28ske8ciezgc6gcebohjshs9k">LinkedIn</title>
            <g clipPath="url(#clip0_202_91845)">
              <path
                d="M14.5455 0H1.45455C0.650909 0 0 0.650909 0 1.45455V14.5455C0 15.3491 0.650909 16 1.45455 16H14.5455C15.3491 16 16 15.3491 16 14.5455V1.45455C16 0.650909 15.3491 0 14.5455 0ZM5.05746 13.0909H2.912V6.18764H5.05746V13.0909ZM3.96291 5.20073C3.27127 5.20073 2.712 4.64 2.712 3.94982C2.712 3.25964 3.272 2.69964 3.96291 2.69964C4.65236 2.69964 5.21309 3.26036 5.21309 3.94982C5.21309 4.64 4.65236 5.20073 3.96291 5.20073ZM13.0938 13.0909H10.9498V9.73382C10.9498 8.93309 10.9353 7.90327 9.83491 7.90327C8.71855 7.90327 8.54691 8.77527 8.54691 9.67564V13.0909H6.40291V6.18764H8.46109V7.13091H8.49018C8.77673 6.58836 9.47636 6.016 10.52 6.016C12.6924 6.016 13.0938 7.44582 13.0938 9.30473V13.0909V13.0909Z"
                fill="currentColor"
              ></path>
            </g>
          </svg>

          <a
            rel="nofollow me"
            className="Link--primary wb-break-all"
            href="https://www.linkedin.com/in/daewoong-kim-46a79a202"
          >
            in/daewoong-kim-46a79a202
          </a>
        </li>
        <li itemProp="social" className="vcard-detail pt-1 ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            role="img"
            aria-labelledby="a277koa1q511wpvj6f850kdy1zdjsmdd"
            className="octicon"
          >
            <title id="a277koa1q511wpvj6f850kdy1zdjsmdd">Instagram</title>
            <g clipPath="url(#clip0_202_91849)">
              <path
                d="M4.66536 0C2.0927 0 0 2.09464 0 4.66797V11.3346C0 13.9073 2.09464 16 4.66797 16H11.3346C13.9073 16 16 13.9054 16 11.332V4.66536C16 2.0927 13.9054 0 11.332 0H4.66536ZM12.6667 2.66667C13.0347 2.66667 13.3333 2.96533 13.3333 3.33333C13.3333 3.70133 13.0347 4 12.6667 4C12.2987 4 12 3.70133 12 3.33333C12 2.96533 12.2987 2.66667 12.6667 2.66667ZM8 4C10.206 4 12 5.794 12 8C12 10.206 10.206 12 8 12C5.794 12 4 10.206 4 8C4 5.794 5.794 4 8 4ZM8 5.33333C7.29276 5.33333 6.61448 5.61428 6.11438 6.11438C5.61428 6.61448 5.33333 7.29276 5.33333 8C5.33333 8.70724 5.61428 9.38552 6.11438 9.88562C6.61448 10.3857 7.29276 10.6667 8 10.6667C8.70724 10.6667 9.38552 10.3857 9.88562 9.88562C10.3857 9.38552 10.6667 8.70724 10.6667 8C10.6667 7.29276 10.3857 6.61448 9.88562 6.11438C9.38552 5.61428 8.70724 5.33333 8 5.33333V5.33333Z"
                fill="currentColor"
              ></path>
            </g>
          </svg>

          <a
            rel="nofollow me"
            className="Link--primary wb-break-all"
            href="https://www.instagram.com/sh_chuck/"
          >
            sh_chuck
          </a>
        </li>
        <li itemProp="social" className="vcard-detail pt-1 ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            role="img"
            aria-labelledby="af4l5klgg7n4ohhp4zitqgw1jyfun5z6"
            className="octicon"
          >
            <title id="af4l5klgg7n4ohhp4zitqgw1jyfun5z6">YouTube</title>
            <path
              d="M15.6656 3.7488C15.4816 3.0608 14.9392 2.5184 14.2512 2.3344C13.0032 2 8 2 8 2C8 2 2.9968 2 1.7488 2.3344C1.0608 2.5184 0.5184 3.0608 0.3344 3.7488C-2.38419e-08 4.9968 0 8.4 0 8.4C0 8.4 -2.38419e-08 11.8032 0.3344 13.0512C0.5184 13.7392 1.0608 14.2816 1.7488 14.4656C2.9968 14.8 8 14.8 8 14.8C8 14.8 13.0032 14.8 14.2512 14.4656C14.94 14.2816 15.4816 13.7392 15.6656 13.0512C16 11.8032 16 8.4 16 8.4C16 8.4 16 4.9968 15.6656 3.7488ZM6.4 10.4784V6.3216C6.4 6.0136 6.7336 5.8216 7 5.9752L10.6 8.0536C10.8664 8.2072 10.8664 8.5928 10.6 8.7464L7 10.8248C6.7336 10.9792 6.4 10.7864 6.4 10.4784Z"
              fill="currentColor"
            ></path>
          </svg>

          <a
            rel="nofollow me"
            className="Link--primary wb-break-all"
            href="https://youtube.com/@d9m-vlog"
          >
            @d9m-vlog
          </a>
        </li>
        <li itemProp="social" className="vcard-detail pt-1 ">
          <svg
            title="Social account"
            aria-hidden="true"
            height="16"
            viewBox="0 0 16 16"
            version="1.1"
            width="16"
            data-view-component="true"
            className="octicon octicon-link"
          >
            <path d="m7.775 3.275 1.25-1.25a3.5 3.5 0 1 1 4.95 4.95l-2.5 2.5a3.5 3.5 0 0 1-4.95 0 .751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018 1.998 1.998 0 0 0 2.83 0l2.5-2.5a2.002 2.002 0 0 0-2.83-2.83l-1.25 1.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Zm-4.69 9.64a1.998 1.998 0 0 0 2.83 0l1.25-1.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.25 1.25a3.5 3.5 0 1 1-4.95-4.95l2.5-2.5a3.5 3.5 0 0 1 4.95 0 .751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018 1.998 1.998 0 0 0-2.83 0l-2.5 2.5a1.998 1.998 0 0 0 0 2.83Z"></path>
          </svg>
          <a
            rel="nofollow me"
            className="Link--primary wb-break-all"
            href="https://knowledge-powerful-but-harmful.tistory.com/"
          >
            https://knowledge-powerful-but-harmful.tistory.com/
          </a>
        </li>
      </ul>
      <div className="story">
        <h3>Now</h3>
        <ul>
          <li>
            <Link to="/now" className="emphasize" state={{ fromHome: true }}>
              I&apos;m doing ...
            </Link>
          </li>
        </ul>
      </div>
      <div className="story">
        <h3>Activity</h3>
        <ul>
          <li>
            <a>Boostcamp Web・Mobile 8th</a> Backend(Node.js) Mentor, 2023
          </li>
        </ul>
      </div>
      <div className="story">
        <h3>Experience</h3>
        <ul>
          <li>Naver (2016 ~ Present)</li>
          <li>KSign (2014 ~ 2016)</li>
        </ul>
      </div>
      <div className="story">
        <h3>Skills</h3>
        <ul>
          <li>Android using Jetpack Compose</li>
          <li>FE using React</li>
          <li>BFF using Nest.js</li>
          <li>AI Application using Local Model</li>
        </ul>
      </div>
      <div className="story">
        <h3>Github Contributions</h3>
        <img
          className="github-graph"
          src="https://ghchart.rshah.org/insidedw"
          alt="GitHub Contributions Graph"
        />
      </div>
      <div className="story">
        <h3>Portfolio</h3>
        <Link
          to={{
            pathname: '/projects',
            state: { fromHome: true },
          }}
          className="more-button"
        >
          More
        </Link>
      </div>
    </QueryClientProvider>
  )
}

export default App
